import { gql } from '@apollo/client';
import { pseudoVirtualHumanFragmentBase } from '@base/queries/VirtualHumanQueries';

export const CREATE_PUBLIC_TOKEN = gql`
  mutation publicToken {
    createPublicToken {
      Token
      PDToken
      Version
      Message
      Organisations {
        ID
      }
      Member {
        ID
        Email
        Name
        FirstName
        Surname
        UserType
        AvatarMedia {
          URL
          TusID
        }
      }
    }
  }
`;

export const READ_VIRTUAL_HUMAN = gql`
  query readOneVirtualHuman($ID: ID!) {
    readOneVirtualHuman(filter: { ID: { eq: $ID } }) {
      ${pseudoVirtualHumanFragmentBase}
      Organisation {
        ID
        Name
        VirtualHumanAPI
      }
    }
  }
`;